import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { LayoutType } from '../types/layouts.esm.js';
import { getDefaultLayout } from './get-selected-layout.esm.js';

function selectDefaultLayout(layouts) {
  var _getDefaultLayout;
  var defaultLayout = getDefaultLayout(layouts);
  if (!defaultLayout) {
    throw new Error('Default layout is missing');
  }
  var defaultLayoutIsSelected = ((_getDefaultLayout = getDefaultLayout(layouts)) === null || _getDefaultLayout === void 0 ? void 0 : _getDefaultLayout.selected) === true;
  if (defaultLayoutIsSelected) {
    return layouts;
  }
  return layouts.filter(function (l) {
    return l.type !== LayoutType.Custom;
  }).map(function (l) {
    return l.type === LayoutType.Default && !l.selected ? _objectSpread2(_objectSpread2({}, l), {}, {
      selected: true
    }) : l;
  }).map(function (l) {
    return l.type !== LayoutType.Default && l.selected ? _objectSpread2(_objectSpread2({}, l), {}, {
      selected: false
    }) : l;
  });
}

export { selectDefaultLayout };
//# sourceMappingURL=select-default-layout.esm.js.map
